module.exports = __webpack_public_path__ + "static/media/9-item-e.2ca6641f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/9-item-e.jpg
// module id = 1219
// module chunks = 33